import { useState } from 'react';
import { feedbackApi } from '@/features/backup/api/backupApi';
import { Modal } from '@/shared/ui/Modal';
import { Button } from '@/shared/ui/Button';

const MAX_CARACTERES = 2000;

export function BotaoFeedback({
  contexto,
  colapsado = false,
}: {
  contexto?: string;
  colapsado?: boolean;
}) {
  const [aberto, setAberto] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [feedback, setFeedback] = useState<{ tipo: 'ok' | 'erro'; msg: string } | null>(null);

  function fechar() {
    if (enviando) return;
    setAberto(false);
    setMensagem('');
    setFeedback(null);
  }

  async function enviar() {
    const texto = mensagem.trim();
    if (!texto) {
      setFeedback({ tipo: 'erro', msg: 'Escreva sua sugestão ou comentário antes de enviar.' });
      return;
    }
    setEnviando(true);
    setFeedback(null);
    try {
      const r = await feedbackApi.enviar(texto, contexto);
      switch (r.tipo) {
        case 'enviado':
          setFeedback({ tipo: 'ok', msg: 'Obrigado! Seu comentário foi enviado.' });
          setMensagem('');
          setTimeout(() => {
            setAberto(false);
            setFeedback(null);
          }, 1500);
          break;
        case 'sem-token':
          setFeedback({
            tipo: 'erro',
            msg:
              'Esta máquina ainda não está registrada no servidor. ' +
              'Vá em "Backup na nuvem" → "Tentar registrar agora" e tente de novo.',
          });
          break;
        case 'falha':
          setFeedback({
            tipo: 'erro',
            msg: `Não foi possível enviar (HTTP ${r.status}): ${r.mensagem}`,
          });
          break;
      }
    } catch (err) {
      setFeedback({
        tipo: 'erro',
        msg: err instanceof Error ? err.message : 'Falha ao enviar feedback',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className={`sidebar__feedback${colapsado ? ' sidebar__feedback--colapsado' : ''}`}
        onClick={() => setAberto(true)}
        aria-label="Enviar comentário ou sugestão"
        data-tooltip-id="sidebar-tip"
        data-tooltip-content={colapsado ? 'Enviar comentário ou sugestão' : undefined}
      >
        <span className="sidebar__feedback-icone" aria-hidden="true">
          💬
        </span>
        <span className="sidebar__feedback-label">Feedback / Comentário</span>
      </button>

      <Modal
        aberto={aberto}
        titulo="Enviar comentário ou sugestão"
        onFechar={fechar}
        rodape={
          <>
            <Button onClick={fechar} disabled={enviando}>
              Cancelar
            </Button>
            <Button variante="primary" onClick={() => void enviar()} disabled={enviando}>
              {enviando ? 'Enviando…' : 'Enviar'}
            </Button>
          </>
        }
      >
        <p style={{ marginTop: 0, color: 'var(--color-text-muted)', fontSize: 14, lineHeight: 1.5 }}>
          Conte o que melhoraria no app — bugs, sugestões de funcionalidade, dificuldades de uso.
          A mensagem é enviada junto com o identificador da sua instalação para que possamos
          retornar.
        </p>
        <textarea
          className="textarea"
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value.slice(0, MAX_CARACTERES))}
          placeholder="Descreva sua sugestão, problema ou comentário…"
          rows={6}
          disabled={enviando}
          style={{ width: '100%', resize: 'vertical', minHeight: 120 }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
          <span style={{ fontSize: 12, color: 'var(--color-text-subtle)' }}>
            {mensagem.length}/{MAX_CARACTERES}
          </span>
        </div>
        {feedback && (
          <div
            style={{
              marginTop: 12,
              padding: '8px 10px',
              borderRadius: 6,
              fontSize: 13,
              background: feedback.tipo === 'ok' ? 'var(--color-success-soft)' : 'var(--color-danger-soft)',
              color: feedback.tipo === 'ok' ? 'var(--color-success)' : 'var(--color-danger)',
              whiteSpace: 'pre-wrap',
            }}
          >
            {feedback.msg}
          </div>
        )}
      </Modal>
    </>
  );
}
